/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store/index";
import { ExchangeRate } from "@/models/api/ExchangeRate";
import {
  getCalculatedValueFromValueInCurrency,
  getCalculatedValueInCurrencyFromValue,
  getExchangeRate,
  getExchangeRateLastAvailable,
} from "@/requests/exchangeRate";
import { CurrencyItems } from "@/models/api/administration/exchangeRate/CurrencyItems";
// import currency from "@/static/currency";

export interface ExchangeRateStateInterface {
  todo: null;
}

export const ExchangeRateState: ExchangeRateStateInterface = {
  todo: null,
};

const ExchangeRateModule = defineModule({
  state: ExchangeRateState as ExchangeRateStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {},
  actions: {
    async getExchangeRate(context, param: { exchangeDate: string; currency: string }): Promise<ExchangeRate> {
      const { rootState } = _moduleActionContext(context);
      const currencies = rootState.user.officeSettings?.currencies as CurrencyItems[];
      const currencyId = currencies.find((v) => v.code === param.currency)?.id as number;
      return await getExchangeRate(currencyId, param.exchangeDate);
    },
    async getLastExchangeRate(
      context,
      param: { exchangeDate: string; currency: string; skipAlert?: undefined | boolean }
    ): Promise<ExchangeRate> {
      const { dispatch, rootState } = _moduleActionContext(context);
      const currencies = rootState.user.officeSettings?.currencies as CurrencyItems[];
      let exchangeRate: ExchangeRate;
      const currencyId = currencies.find((v) => v.code === param.currency)?.id as number;
      if (param.skipAlert === true) {
        exchangeRate = await getExchangeRateLastAvailable(currencyId, param.exchangeDate);
      } else {
        try {
          exchangeRate = await dispatch.getExchangeRate(param);
        } catch (exception) {
          exchangeRate = await getExchangeRateLastAvailable(currencyId, param.exchangeDate);
        }
      }
      return exchangeRate;
    },
    //z waluty bazowej apki (pln) na walutę transakcji (w wiekszosci przypadków z pln na currency)
    async getCalculatedValueInCurrencyFromValue(context, param: { value: number; exchangeRate: number }) {
      return await getCalculatedValueInCurrencyFromValue(param.value, param.exchangeRate);
    },
    //z waluty transakcji na walutę bazową apki (w wiekszosci przypadków z currency na pln)
    async getCalculatedValueFromValueInCurrency(context, param: { valueInCurrency: number; exchangeRate: number }) {
      return await getCalculatedValueFromValueInCurrency(param.valueInCurrency, param.exchangeRate);
    },
  },
});

export default ExchangeRateModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, ExchangeRateModule);
// noinspection JSUnusedLocalSymbols
const _moduleActionContext = (context: any) => moduleActionContext(context, ExchangeRateModule);
